// src/components/Hero.jsx
import React from "react"
import logo from "../assets/2merative_logo.webp"
import CtaButtons from "./home/CtaButtons.jsx"

const PILLARS = ["Premium Websites", "SEO & GEO", "Google Ads", "AI Chatbots & Integrations"]

// Uses the shared brand gradient (.brand-hero in index.css). The homepage
// variant keeps the original light blue behind the logo; all text starts at
// or below the #457b9d stop so white text meets WCAG AA.
export default function Hero() {
  return (
    <section className="brand-hero brand-hero--home relative overflow-hidden text-white">
      <div className="relative mx-auto flex max-w-5xl flex-col items-center px-4 pb-16 pt-28 text-center sm:px-6 sm:pb-20 sm:pt-32 lg:pb-24">
        <img
          src={logo}
          alt="2merative"
          width={240}
          height={240}
          loading="eager"
          decoding="async"
          fetchpriority="high"
          className="hero-logo h-40 w-40 select-none rounded-3xl object-contain shadow-2xl ring-1 ring-white/50 sm:h-48 sm:w-48 lg:h-56 lg:w-56"
        />

        {/* The slogan is also baked into the logo artwork at a small size; this
            is the readable, accessible version. */}
        <p className="mt-6 text-xl font-semibold tracking-wide text-white sm:text-2xl">
          Iterate. Create. Elevate.
        </p>

        <p className="mt-8 text-sm font-semibold uppercase tracking-[0.16em] text-white">
          Web design, SEO &amp; Google Ads · Adelaide
        </p>

        <h1 className="mt-5 max-w-4xl text-4xl font-bold leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">
          Your digital presence should work as hard as your business.
        </h1>

        <p className="mt-6 max-w-2xl text-lg leading-relaxed text-blue-50 sm:text-xl">
          We help established businesses strengthen their online presence, improve their
          visibility across search and AI-powered discovery, and create better customer
          experiences through premium websites, SEO &amp; GEO, Google Ads, AI chatbots and
          ongoing digital support.
        </p>

        <CtaButtons tone="light" className="mt-10 justify-center" />

        <ul className="mt-12 flex w-full flex-wrap justify-center gap-x-6 gap-y-2 border-t border-white/15 pt-6 text-sm font-medium text-blue-100">
          {PILLARS.map((pillar) => (
            <li key={pillar} className="flex items-center gap-2">
              <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-brand-sky" />
              {pillar}
            </li>
          ))}
        </ul>
      </div>

      <style>{`
        /* Original 2merative logo animation: one full spin on load, quick spin on hover. */
        @keyframes spinOnce {
          from { transform: rotate(0); }
          to { transform: rotate(360deg); }
        }
        /* Same spin under a separate name so hover restarts it after the load spin. */
        @keyframes spinHover {
          from { transform: rotate(0); }
          to { transform: rotate(360deg); }
        }
        .hero-logo {
          animation: spinOnce 1.5s ease-in-out both;
          will-change: transform;
        }
        .hero-logo:hover {
          animation: spinHover 0.35s ease-in-out both;
        }

        @media (prefers-reduced-motion: reduce) {
          .hero-logo,
          .hero-logo:hover {
            animation: none !important;
          }
        }
      `}</style>
    </section>
  )
}
